import { LinkProps } from '@chakra-ui/react';
import { Link } from 'components/UI';
import { useLocation } from 'react-router-dom';
import { checkRouteActive } from 'utils/navigation';
import { ISidebarItem } from 'types/layout/ISidebarItem';

type SidebarItemProps = LinkProps & Omit<ISidebarItem, 'id'>;

const SidebarItem = ({ route, icon, text }: SidebarItemProps) => {
  const location = useLocation();

  const isActive = checkRouteActive(route, location);

  return (
    <Link
      data-testid="sidebar-item"
      to={route}
      aria-current={isActive ? 'true' : 'false'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 4,
        px: 5,
        textDecor: 'none',
        color: isActive ? 'white' : 'base1FontColour.500',
        textTransform: 'uppercase',
        bgColor: isActive ? 'primaryThemeColour.400' : 'transparent',
        _hover: {
          color: 'white',
          textDecor: 'none',
          bgColor: 'primaryThemeColour.400',
        },
      }}
    >
      {icon}
      {text}
    </Link>
  );
};

export default SidebarItem;
